const namedHtmlEntities = {
    amp: '&',
    apos: "'",
    gt: '>',
    lt: '<',
    nbsp: '\u00a0',
    quot: '"',
}

const decodeNumericHtmlEntity = entity => {
    const isHex = entity.toLowerCase().startsWith('#x')
    const codePoint = Number.parseInt(entity.slice(isHex ? 2 : 1), isHex ? 16 : 10)

    if (!Number.isFinite(codePoint)) return null

    try {
        return String.fromCodePoint(codePoint)
    } catch (e) {
        return null
    }
}

// Numeric references plus the named entities above — no DOM, so it is safe on hot paths that
// run outside a render (height estimators) and behaves the same in node.
export const decodeBasicHtmlEntities = value => {
    if (value == null) return value

    const text = String(value)
    if (!text.includes('&')) return text

    return text.replace(/&(#x[0-9a-f]+|#\d+|[a-z][a-z0-9]+);/gi, (match, entity) => {
        if (entity.startsWith('#')) {
            return decodeNumericHtmlEntity(entity) ?? match
        }

        return namedHtmlEntities[entity.toLowerCase()] ?? match
    })
}

export const decodeHtmlEntities = value => {
    if (value == null) return value

    const text = String(value)
    if (!text.includes('&')) return text

    if (typeof document !== 'undefined') {
        const textarea = document.createElement('textarea')
        textarea.innerHTML = text
        return textarea.value
    }

    return decodeBasicHtmlEntities(text)
}
